export default "__VITE_ASSET__DYc0ZB5j__"